import { css } from 'emotion';

export const sortableColumn = (sortable?: boolean) => css`
  ${!sortable && 'pointer-events: none;'};
`;
